import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IChild} from '../../components/reports/concept-explorer/heated-map-panel/TypesHeatMap';
import {IConceptExplorer} from '../../api/types/conceptExplorer.type';

interface renderJSONPayloadProps extends IConceptExplorer {
  keyword: string;
  currentLevelIndex: number;
}
interface ComExplorerState {
  backSourceLabel?: string | null;
  backSourcePath?: string | null;
  sourceId: string | null;
  shoppingCartValue?: IChild[] | null;
  communicationStateValue?: any;
  communicationShowByFilters?: {[key: string]: string | number | null} | null;
  renderJSONPayload?: renderJSONPayloadProps | null;
  sourceName?: string | null;
  navigationSourceType?: string | null;
  sourceSelectionText?: string | null;
}

const initialState: ComExplorerState = {
  backSourceLabel: null,
  backSourcePath: null,
  sourceId: null,
  shoppingCartValue: null,
  communicationStateValue: null,
  communicationShowByFilters: null,
  renderJSONPayload: null,
  sourceName: null,
  navigationSourceType: null,
  sourceSelectionText: null,
};

const comExplorerSlice = createSlice({
  name: 'comExplorer',
  initialState,
  reducers: {
    setReportDetails(state, action: PayloadAction<ComExplorerState>) {
      const setKeys = Object.keys(initialState);
      setKeys.forEach((key) => {
        (state as any)[key] =
          action.payload[key as keyof ComExplorerState] ?? null;
      });
    },
    setComExplorerShowByFilters(
      state,
      action: PayloadAction<{[key: string]: string | number | null}>
    ) {
      state.communicationShowByFilters = action.payload;
    },
    setRenderJSONPayload(state, action: PayloadAction<renderJSONPayloadProps>) {
      state.renderJSONPayload = action.payload;
    },
    clearReportBackNavigation(state) {
      const resetKeys = Object.keys(initialState);
      resetKeys.forEach((key) => {
        (state as any)[key] = initialState[key as keyof ComExplorerState];
      });
    },
    clearComExplorerShowByFilters(state) {
      state.communicationShowByFilters = null;
    },
  },
});

export const {
  setReportDetails,
  clearReportBackNavigation,
  setComExplorerShowByFilters,
  setRenderJSONPayload,
  clearComExplorerShowByFilters,
} = comExplorerSlice.actions;
export default comExplorerSlice.reducer;
